export class Listlst {
    id: string = "00000000-0000-0000-0000-000000000000";
    agencyId: string | null;
    listName: string;
    listCode: string;
    isAvailableToAgency: boolean;
}

export class sortingObj {
    itemperpage: number = 20;
    currentPgNo: number = 1;
    shortcolumn: string = "ListName";
    shortType: string = 'asc';
}

export class functionpermission {
    listcreate: boolean = true;
    listdelete: boolean = true;
    listupdate: boolean = true;

}

export class columnWidth {
    column: string = "";
    width: number = 0;
}

export class ColumnChangeBO {
    id: string = "00000000-0000-0000-0000-000000000000";
    userid: string = "00000000-0000-0000-0000-000000000000";
    agencyId: string = "00000000-0000-0000-0000-000000000000";
    column: string;
}

export class WhereCondition {
    field: string = "listcode";
    value: string = "";
    operator: string = "startswith";
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
    matchCase: boolean = false;
}

export class GetListBO {
    orderColumn: string = "ListName";
    orderType: string = "asc";
    pageitem: number;
    currentpageno: number = 1;
    userId: string = "00000000-0000-0000-0000-000000000000";
    field: string = "listCode";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
}




export class GetListNewBO {

    role: string;
    user: string | null;

    searchColumn: string;
    searchText: string;
    userId: string | null;
    agencyId: string | null;
    locationId: string | null;
    currentpageno: number = 1;
    orderType: string = "asc";
    pageitem: number = 10;
    orderColumn: string = "listName";
    type: string = "string";
    field: string = "listName";
    value: string = "";
    operator: string = "startswith";
    matchCase: boolean = false;
}

export class saveListBO {
    id: string;
    listName: string;
    listCode: string;
    isAvailableToAgency: boolean = false;
}